var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "newsletter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GLOBAL---COMMUNICATIONS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communications---Letters---Active-Modal",
    transform: "translate(-696.000000, -139.000000)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog",
    transform: "translate(468.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(4.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-Area",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(0.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "newsletter",
    transform: "translate(206.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#002C8B",
    points: "8 14.2 0 20 0 44 44 44 44 20 36 14.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#00B5E1",
    points: "8 24.4 8 0 36 0 36 24.4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 20,
    x2: 44,
    y2: 44,
    id: "Shape",
    stroke: "#002C8B"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 20,
    x2: 22,
    y2: 32,
    id: "Shape",
    stroke: "#002C8B"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 10,
    x2: 28,
    y2: 10,
    id: "Shape",
    stroke: "#00B5E1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 18,
    x2: 28,
    y2: 18,
    id: "Shape",
    stroke: "#00B5E1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/Letter.af5cee84.svg";
export { ForwardRef as ReactComponent };